import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';   
const UserInfoRow = ({ icon, label, value, onEdit, isEditBtn = true, classflexinBlock }) => {
  return (
    <Box display="flex" alignItems="center" justifyContent="space-between" p={1} mb={1} sx={{ border: '1px solid #DADCE0', background:{xs:'#FAFAFA', sm:'#FAFAFA', md:'#FAFAFA'}, gap:2, borderRadius:'8px', minHeight:{xs:'54px', sm:'58px'}, }}>
      <Box display="flex" alignItems="center" sx={{width:'100%',}}>
        {icon}
        <Box  className={classflexinBlock} sx={{display:{xs:'block', sm:'flex'}, justifyContent:'space-between', alignItems:'center', gap:{xs:0, sm:2,}, width:'100%', marginLeft: {
          xl: '16px',
          lg: '5px',
          md: '16px',
          sm: '16px',
          xs: '16px'
        }}}>
          <Typography fontWeight={600} sx={{ fontSize: {xs:'13px', sm:'14px',  lg: '12px' , md: '14px' , xl: '14px'}, color: '#2B1E1A', whiteSpace:'nowrap', }}>{label}</Typography>
          <Typography fontWeight={400} sx={{ fontSize: { xs: '11px', sm: '14px', xl: '14px', width:'100%' }, textAlign:{xs:'left', sm:'right'}, color: '#5F6368', marginLeft: { xs: '0px', lg: 'unset' } }}>
            {value}
          </Typography>
        </Box>
      </Box> 
    </Box>
  );
};

export default UserInfoRow;
